var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineKeySquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.59 18.23-1.19-.16c-.72-.1-1.35-.72-1.46-1.46l-.17-1.21c-.07-.48.13-1.09.48-1.45l2.28-2.28c-.34-1.62.15-3.3 1.34-4.48a4.919 4.919 0 0 1 6.94 0c.93.93 1.44 2.16 1.44 3.47s-.51 2.55-1.44 3.47a4.913 4.913 0 0 1-4.48 1.33l-2.29 2.28c-.29.31-.78.51-1.23.51-.07 0-.15 0-.22-.02zm2.34-9.98c-.9.9-1.22 2.21-.85 3.43.08.27.01.55-.19.75l-2.58 2.58c-.02.03-.06.14-.06.18l.17 1.2c.01.06.12.17.18.18l1.2.17c.05-.01.15-.03.18-.06l2.59-2.59c.2-.2.49-.26.75-.18 1.21.38 2.52.06 3.42-.84.64-.64 1-1.5 1-2.41 0-.91-.35-1.77-1-2.41-.65-.66-1.53-1-2.4-1-.87 0-1.75.33-2.41 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.92 16.81-.86-.86a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.86.86c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22zM12.99 11.73c-.12-.05-.23-.13-.32-.22a.976.976 0 0 1 0-1.41c.23-.24.58-.35.9-.28.06.02.13.03.19.06s.12.06.17.09c.05.04.11.08.15.13a.976.976 0 0 1 .22 1.09c-.05.12-.12.23-.22.32-.19.19-.44.29-.7.29-.14 0-.27-.02-.39-.07z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineKeySquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-key-square.00bf88293061270dce883c18b37dab2c.svg";
export { ForwardRef as ReactComponent };